import type {
	ColPresetType,
	PageNameType,
} from '../../../redux/clientConfiguration/clientConfigurationSlice';
import type { DashboardWidgetType } from '../../dashboard/Dashboard.types';

// Same row useDashboard saves (DASHBOARD_WIDGETS_PARAMETER). Not imported from
// there: useDashboard pulls in the store, and the saga importing this file
// would then import itself through the store.
export const USER_DASHBOARD_PARAMETER = 'dashboardWidgets';
export const USER_COLUMNS_PARAMETER = 'columns';
export const DASHBOARD_TEMPLATES_PARAMETER = 'dashboardTemplates';
export const COLUMN_TEMPLATES_PARAMETER = 'columnTemplates';
/**
 * Parameter of a user row between `/create` and the PUT that hands it to the
 * user. `/create` files every row under the caller, so for that moment the
 * row sits among the admin's own rows; nothing reads this parameter.
 */
export const USER_CONFIG_PENDING_PARAMETER = 'widgetsGridsPendingRow';

/**
 * Temporarily the existing admin role; switch the action to 'ManageUsers'
 * once the backend adds a dedicated role for per-user config.
 */
export const CONFIGURATOR_ROLE = {
	resource: 'ClientConfiguration',
	action: 'GetAll',
} as const;

/** `CONFIGURATOR_ROLE` as the flat `resource.action` string routes/menus use. */
export const CONFIGURATOR_ROLE_KEY = `${CONFIGURATOR_ROLE.resource}.${CONFIGURATOR_ROLE.action}`;

export type DashboardTemplate = {
	id: string;
	name: string;
	widgets: DashboardWidgetType[];
};

export type ColumnTemplate = {
	id: string;
	name: string;
	page: PageNameType;
	preset: ColPresetType;
};

export type AttachMode = 'replace' | 'add';

/** Value of a user's `columns` row: presets per page name. */
export type PresetsByPage = Record<string, ColPresetType[]>;

/** Pages whose tables have column presets (settings, identity, accessGroups have none). */
export const PRESET_PAGES: PageNameType[] = [
	'results',
	'customers',
	'orders',
	'vehicles',
	'drivers',
	'products',
	'products/groups',
	'contracts',
	'contracts/details',
	'spy',
	'weightings',
	'destPoint',
	'destPoint/details',
	'cards',
	'cards/cardtimes',
	'licenses',
	'users',
	'audit',
	'warehouse',
	'inventorization',
	'IoT',
	'taskScheduler',
	'requestedMsg',
];
